import { Injectable } from '@angular/core';
import { customConfig } from "../../custom/custom-config";
import { CoreCOMService } from './com.service';
import Utils from '../shared/utils';

@Injectable({
  providedIn: 'root'
})
export class ChefCampaignsService {
  private isloaded = false;
  constructor(
    private _coreCOMService: CoreCOMService,
  ) { }

  public isActve(): boolean {
    return customConfig.chef_campaigns_cid !== "" && customConfig.chef_campaigns_eid !== "";
  }

  public load(): void {
    if (!this.isloaded && this.isActve()) {
      const initScript = document.createElement('script');
      initScript.src = "https://api.skynet.mcanism.com/static/js/init.js";
      document.body.appendChild(initScript);
      this.isloaded = true;
    }
  }

  public addSalesEventScriptIfActive(element: HTMLElement, order_id: string, amount_cents: number, currency_symbol: string): void {

    if (this.isloaded && this.isActve()) {
      const amount = Utils.moneyRound(amount_cents / 100);
      let currency = currency_symbol;
      if (currency === '€') {
        currency = 'EUR';
      } else if (currency === '£') {
        currency = 'GBP';
      } else {
        //keep currency as is
      }

      const salesScript = document.createElement('script');
      salesScript.src = "https://api.skynet.mcanism.com/static/js/confirm.js";
      salesScript.setAttribute('data-type', 'sale');
      salesScript.setAttribute('data-cid', customConfig.chef_campaigns_cid);
      salesScript.setAttribute('data-eid', customConfig.chef_campaigns_eid);
      salesScript.setAttribute('data-id', order_id);
      salesScript.setAttribute('data-amount', amount.toString());
      salesScript.setAttribute('data-currency', currency);
      const salesNoScript = document.createElement('noscript');
      const salesImg = document.createElement('img');
      salesImg.src = `https://api.skynet.mcanism.com/p?type=sale&eid=${customConfig.chef_campaigns_eid}&id=${order_id}&amount=${amount}&currency=${currency}`;
      salesImg.setAttribute('alt', '');
      salesImg.setAttribute('width', '1');
      salesImg.setAttribute('height', '1');
      salesNoScript.appendChild(salesImg);

      element.appendChild(salesScript);
      element.appendChild(salesNoScript);
    }
  }
}